const l=(l,t)=>"fulfilled"===l.status?l.value:t;export{l as getFulfilledPromiseSettledResult};
